import styled, { css } from "styled-components";
import { ProfileCard } from "../../components/atom";

export const CertifyCardWrapper = styled(ProfileCard)<{ showTitle: boolean }>`
  padding: ${(p) => (p.showTitle ? "20px 24px 18px" : "22px 24px")};
  position: relative;
  @media (max-width: 1500px) {
    height: unset;
  }
`;

export const CertifyTitle = styled.div`
  color: #d9dfe0;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
`;

const CardStyleMap = new Map([
  [
    "small",
    css`
      height: 54px;
      width: 360px;
    `,
  ],
  [
    "middle",
    css`
      height: 80px;
      width: 50%;
      padding: 15px 16px;
    `,
  ],
  [
    "large",
    css`
      height: 80px;
    `,
  ],
  [
    "uncertified-large",
    css`
      height: 80px;
      width: 100%;
      padding: 0 8px;
    `,
  ],
  [
    "enterprise-large",
    css`
      height: 110px;
      width: 100%;
    `,
  ],
]);

export const IconWrapper = styled.div``;

export const CommonCard = styled.div<{
  size?: string;
  width?: string;
  disabled?: boolean;
}>`
  position: relative;
  display: flex;
  width: ${(p) => p.width || "100%"};
  min-width: ${(p) => p.width || "0px"};
  border-radius: 8px;
  background: #1c1e21;
  ${(p) => CardStyleMap.get(p.size || "large")};
  ${IconWrapper} {
    ${(p) =>
      p.size === "small" &&
      css`
        padding: 6px;
      `};
    svg {
      width: ${(p) => p.size === "small" && "42px"};
      height: ${(p) => p.size === "small" && "42px"};
    }
  }
  .title {
    font-size: 14px;
    color: #e8f4f5;
    font-weight: 600;
  }
  .sub-title {
    font-size: 12px;
    color: #bfc2c3;
    .interval {
      color: #44464b;
      margin: 0 8px;
    }
  }
  .tip {
    position: absolute;
    right: 0;
    top: 0;
    width: fit-content;
    justify-content: center;
    background: #111214;
    padding: 0 8px;
    border-radius: 0 8px 0 8px;
    line-height: 23px;
    display: flex;
    align-items: center;
    color: #df4036;
    font-size: 12px;
    margin: unset !important;
    &.pending {
      color: #0c9ad6;
    }
    &.checked {
      color: #13cb75;
    }
    &.expired {
      color: #9ba2b0;
    }
    svg {
      margin-right: 4px;
    }
  }
  &.arrow-card,
  &.info-card {
    border: 1px solid transparent;
    &:hover {
      cursor: ${(p) => (p.disabled ? "not-allowed" : `pointer`)};
      border: ${(p) =>
        p.disabled ? "1px solid transparent" : `1px solid var(--main-color)`};
      .right {
        color: var(--main-color);
        svg path {
          fill: ${(p) => !p.disabled && `var(--main-color)`};
        }
      }
    }
  }
  .right {
    color: #757879;
    font-size: 12px;
    line-height: 16px;
    position: absolute;
    display: flex;
    align-items: center;
    right: 16px;
    top: 50%;
    transform: translate(0, -50%);
    cursor: pointer;
  }
  .more-right {
    right: 26px;
  }
`;

export const CertifyTimeText = styled.span`
  border-radius: 4px;
  background: #292b2f;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  margin-left: 10px;
  padding: 3px 6px;
  font-weight: 400;
`;

export const ChangeBtnGroup = styled.div`
  height: 24px;
  line-height: 24px;
  font-size: 14px;
  display: flex;
  gap: 16px;
  color: #9ba2b0;
  cursor: pointer;
  a {
    color: #9ba2b0;
  }
  span {
    position: relative;
  }
  a:hover,
  span:hover {
    color: var(--main-color);
  }
`;

export const PersonalCertificateLink = styled.div`
  display: inline;
  margin-left: 14px;
  color: #13cb75;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
`;

export const RedPoint = styled.div`
  width: 8px;
  height: 8px;
  background-color: #ef4a33;
  border-radius: 50%;
  position: absolute;
  top: -0;
  right: -8px;
`;
